<template>
  <b-modal
    size="lg"
    title="EDITAR ITEM"
    id="edit_item"
    no-close-on-backdrop
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form v-if="purchase_item" @submit.prevent="evOnSubmit">
      <b-overlay :show="loadingVerify" opacity="0.99">
        <b-row v-if="!imported_nfe">
          <b-col>
            <h5 class="m-0">{{ purchase_item.name }}</h5>
            <!-- :disabled="purchase_item.stock_item_locked || imported_nfe" -->
            <!-- <v-autocomplete-default
              disabled
              :items="stock_items"
              item-text="name"
              item-value="id"
              label="ITEM"
              v-model="stock_item_id"
            /> -->
          </b-col>
        </b-row>
        <div class="row border-bottom pb-3" v-if="imported_nfe">
          <div class="col-md-12 pt-0 pb-0">
            <h6 v-if="purchase_item.nfe_code" class="worksansr m-0">
              {{ purchase_item.nfe_code }}
            </h6>
            <h5 v-if="exist_nfe_item && purchase_item.nfe_name">
              {{ purchase_item.nfe_name }}
            </h5>
            <v-text-field-default
              v-if="!exist_nfe_item && link_stock_item == 'NAO'"
              type="text"
              label=""
              v-model="purchase_item_nfe_name"
            />
          </div>
          <div v-if="!exist_nfe_item" class="col-md-12 pb-0">
            <h6>INFORMAÇÕES PARA O CADASTRO DO PRODUTO/MEDICAMENTO</h6>
          </div>
          <div v-if="!exist_nfe_item" class="col-md-12 pb-0 text-center">
            <h6>
              VINCULAR O PRODUTO/MEDICAMENTO DA NOTA FISCAL EM UM
              PRODUTO/MEDICAMENTO JÁ CADASTRADO?
            </h6>
            <b-form-group label="">
              <b-form-radio-group
                id="radio-group-2"
                v-model="link_stock_item"
                name="radio-sub-component"
                @change="handleChangeLinkStockItem"
              >
                <b-form-radio value="SIM">SIM</b-form-radio>
                <b-form-radio value="NAO">NÃO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
          <div
            class="col-md-12 pt-0 pb-0"
            v-if="!exist_nfe_item && link_stock_item == 'SIM'"
          >
            <label-required-field
              label="SELECIONE O PRODUTO/MEDICAMENTO QUE IRÁ VINCULAR"
            />
            <v-autocomplete-default
              :items="stock_items"
              item-text="name"
              item-value="id"
              label=""
              placeholder="DIGITE PARA PESQUISAR..."
              v-model="nfe_stock_item_id"
              @search="handleSearch"
              @change="handleChange"
            />
          </div>
          <div v-if="!exist_nfe_item" class="col-md-4 pt-0 pb-0">
            <v-select-default
              disabled
              alternativeLabel
              required
              label="TIPO"
              item-text="name"
              item-value="value"
              :items="[
                { value: 'PRODUCT', name: 'PRODUTO' },
                { value: 'MEDICINE', name: 'MEDICAMENTO' },
              ]"
              v-model="imported_nfe_type"
              @change="handleTypeItem"
            />
          </div>
          <div v-if="!exist_nfe_item" class="col-md-4 pt-0 pb-0">
            <v-select-default
              :disabled="link_stock_item == 'SIM'"
              alternativeLabel
              required
              label="UNIDADE DE MEDIDA"
              item-text="name"
              item-value="id"
              :items="[
                { id: null, name: 'SELECIONE...' },
                ...stock_item_units_of_measurement,
              ]"
              v-model="stock_item_unit_of_measurement_id"
              @change="handleChangeUnitOfMeasurementId"
            />
          </div>
          <div v-if="!exist_nfe_item" class="col-md-4 pt-0 pb-0">
            <label-required-field
              :label="`QUANTIDADE ${
                stock_item_unit_of_measurement &&
                stock_item_unit_of_measurement.id
                  ? `EM ${stock_item_unit_of_measurement.abbreviation}`
                  : ''
              }`"
            />
            <v-text-field-default
              :disabled="link_stock_item == 'SIM'"
              label=""
              type="text"
              v-model="size"
              @input="handleChangeSize"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 pb-0">
            <h6>INFORMAÇÕES PARA O CADASTRO DA COMPRA</h6>
          </div>
          <div class="col-md-4 pt-0">
            <label>LOTE</label>
            <v-text-field-default label="" v-model="lot" />
          </div>
          <div class="col-md-4 pt-0 pb-0">
            <label>DESCRIÇÃO</label>
            <v-text-field-default label="" v-model="description" />
          </div>
          <div class="col-md-12 p-0"></div>
          <div class="col-md-4 pt-0 pb-0">
            <label-required-field label="QUANTIDADE" />
            <v-text-field-default
              type="text"
              label=""
              :persistent-hint="Boolean(amountHint)"
              :hint="amountHint"
              v-model="amount"
              @input="handleInputAmount"
            />
          </div>
          <div
            v-if="purchase_item.stock_item_type == 'PRODUCT'"
            class="col-md-4 pt-0 pb-0"
          >
            <label-required-field
              :label="`QUANTIDADE ${
                stock_item_unit_of_measurement &&
                stock_item_unit_of_measurement.id
                  ? `EM ${stock_item_unit_of_measurement.abbreviation}`
                  : ''
              }`"
            />
            <v-text-field-default
              disabled
              type="text"
              label=""
              v-model="quantity"
            />
          </div>
          <div class="col-md-12 p-0"></div>
          <div class="col-md-4 pt-0 pb-0">
            <label>DATA DE VALIDADE</label>
            <v-text-field-default
              :type="
                purchase_item.stock_item_type == 'PRODUCT' ? 'date' : 'month'
              "
              label=""
              v-model="due_date"
            />
          </div>
          <div class="col-md-4 pt-0 pb-0">
            <label-required-field label="GRUPO" />
            <v-autocomplete-default
              label=""
              :items="available_groups"
              v-model="stock_group_id"
            />
          </div>
          <div class="col-md-4 pt-0 pb-0">
            <label-required-field label="VALOR UNITÁRIO" />
            <v-text-field
              outlined
              dense
              disabled
              type="text"
              v-model="unitary_value"
              @keyup="handleUnitaryValue($event.target.value)"
            />
          </div>
          <div class="col-md-4 pt-0 pb-0">
            <label-required-field label="VALOR TOTAL" />
            <v-text-field
              outlined
              dense
              disabled
              type="text"
              v-model="value"
              @keyup="handleValue($event.target.value)"
            />
          </div>
        </div>
        <warning-required-fields />
        <errors-messages :errors="errors" />
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn-save :disabled="btnSaveDisabled || loading" type="submit" />
          </b-col>
        </b-row>
      </b-overlay>
    </b-form>
  </b-modal>
</template>

<script>
import VBtnSave from "../../../Components/VBtnSave.vue";
import VAutocompleteDefault from "../../../Components/VAutocompleteDefault.vue";
import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";
import VSelectDefault from "../../../Components/VSelectDefault.vue";
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import WarningRequiredFields from "../../../Components/WarningRequiredFields.vue";
import LabelRequiredField from "../../../Components/LabelRequiredField.vue";

import { formatValueOnKeyUp } from "../../../../lib/format";

import api from "../../../../services/api";

export default {
  name: "EditItem",

  components: {
    VBtnSave,
    VAutocompleteDefault,
    VTextFieldDefault,
    VSelectDefault,
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },

  props: {
    type: { type: String },
    purchase_item: { type: Object },
    provider_id: { type: [Number, String] },
    stock_items: { type: Array, required: true },
    stock_items_by_provider_id: { type: Array, required: true },
    stock_groups: { type: Array, required: true },
    stock_group_has_stock_item_category: { type: Array, required: true },
    stock_item_categories: { type: Array, required: true },
    stock_item_units_of_measurement: { type: Array, required: true },
    imported_nfe: { type: Boolean, required: false, default: false },
    nfe: { type: [Object, String, Boolean], required: false, default: null },
    nfe_change_name_item: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data() {
    return {
      errors: [],
      loading: false,
      loadingVerify: false,

      link_stock_item: "SIM",
      stock_item_id: null,
      nfe_stock_item_id: null,
      amount: "",
      quantity: "",
      lot: "",
      description: "",
      due_date: "",
      stock_group_id: null,
      stock_item_unit_of_measurement_id: null,
      stock_item_unit_of_measurement: null,
      value: "",
      unitary_value: "",
      size: "",
      imported_nfe_type: "PRODUCT",
      exist_nfe_item: false,
      stock_item_provider_code: null,
      purchase_item_nfe_name: "",
    };
  },

  computed: {
    stock_item() {
      return this.stock_items.find((item) => item.id === this.stock_item_id);
    },

    unit_of_measurement() {
      if (!this.stock_item) return undefined;

      return this.stock_item_units_of_measurement.find(
        (unit) => unit.id === this.stock_item.stock_item_unit_of_measurement_id
      );
    },

    available_groups() {
      if (!this.imported_nfe) {
        return this.stock_groups;
      } else {
        return this.stock_groups;
      }
    },

    amountHint() {
      const msg = this.purchase_item.nfe_amount
        ? this.purchase_item.nfe_amount
        : "";

      if (!msg) return "";

      const append = this.unit_of_measurement?.name ?? "";
      return append ? `${msg} em ${append}` : msg;
    },

    btnSaveDisabled() {
      if (this.purchase_item.stock_item_type == "MEDICINE" && !this.lot)
        return true;
      if (this.stock_group_id === null) return true;
      if (!this.imported_nfe && this.stock_item_id === null) return true;
      if (Number(this.amount) <= 0) return true;
      if (Number(this.value) <= 0) return true;

      return false;
    },
  },

  created() {
    this.retrieve().then();
  },

  watch: {
    type() {
      this.imported_nfe_type = this.type;
    },

    purchase_item() {
      let { purchase_item } = this;

      this.errors = [];
      this.imported_nfe_type = this.type;
      this.nfe_stock_item_id = null;
      this.exist_nfe_item = false;
      this.stock_item_provider_code = null;

      if (purchase_item) {
        this.$bvModal.show("edit_item");

        if (purchase_item.imported_nfe) {
          this.purchase_item_nfe_name = purchase_item.nfe_name;
          if (purchase_item.imported_nfe_type) {
            this.imported_nfe_type = purchase_item.imported_nfe_type;
            this.purchase_item.stock_item_type =
              purchase_item.imported_nfe_type;
          }
          this.verifyNFeItem();
        }

        if (purchase_item.unitary_value) {
          let { unitary_value } = purchase_item;

          this.unitary_value = formatValueOnKeyUp(String(unitary_value));
        }

        this.size = purchase_item.size;
        this.quantity = purchase_item.quantity;

        this.handleChangeUnitOfMeasurementId(
          purchase_item.stock_item_unit_of_measurement_id
        );

        this.handleTypeItem("PRODUCT");
        this.handleChangeUnitOfMeasurementId(
          this.stock_item_unit_of_measurement_id
        );
      }
    },
  },

  methods: {
    handleChangeSize() {
      let { amount, size } = this;

      if (amount) {
        this.quantity = parseFloat(amount) * parseFloat(size);
      }
    },

    handleInputAmount() {
      let { amount, size, purchase_item } = this;

      if (amount) {
        amount = String(amount).replace(",", ".");

        this.quantity = parseFloat(amount) * parseFloat(size);

        let { value } = purchase_item;

        value = String(value)
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(",", ".");

        let unitary_value = parseFloat(value) / parseFloat(amount);

        this.unitary_value = formatValueOnKeyUp(
          String(unitary_value.toFixed(2))
        );
      }
    },

    handleChangeLinkStockItem() {
      this.nfe_stock_item_id = null;
      this.stock_item_id = null;
      this.stock_item_unit_of_measurement_id = null;
      this.size = "";
      this.imported_nfe_type = this.type;
      this.stock_item_unit_of_measurement = null;
    },

    handleSearch(value) {
      this.$emit("search", value);
    },

    handleChange(id) {
      let { stock_items } = this;

      let stock_item = stock_items.find((item) => item.id == id);

      if (stock_item) {
        this.stock_item_id = stock_item.id;
        this.stock_item_unit_of_measurement_id =
          stock_item.stock_item_unit_of_measurement_id;
        this.size = stock_item.size;
        this.imported_nfe_type = stock_item.stock_item_type;
        this.purchase_item.stock_item_type = stock_item.stock_item_type;
        this.handleChangeUnitOfMeasurementId(
          stock_item.stock_item_unit_of_measurement_id
        );
        this.handleInputAmount();
      }
    },

    handleChangeUnitOfMeasurementId(id) {
      this.stock_item_unit_of_measurement = null;
      if (id) {
        let find = this.stock_item_units_of_measurement.find(
          (unit) => unit.id == id
        );

        if (find) {
          this.stock_item_unit_of_measurement = find;

          this.purchase_item.stock_item_unit_of_measurement_id = find.id;
          this.purchase_item.unit_of_measurement_abbreviation =
            find.abbreviation;
        }
      }
    },

    handleTypeItem(value) {
      let { amount, size } = this;

      if (["PRODUCT", "MEDICINE"].includes(value)) {
        this.purchase_item.stock_item_type = value;

        if (amount) {
          this.quantity = parseFloat(amount) * parseFloat(size);
        }
      }
    },

    handleValue(value) {
      this.value = formatValueOnKeyUp(value);
    },

    handleUnitaryValue(value) {
      this.unitary_value = formatValueOnKeyUp(value);
    },

    async retrieve() {
      this.errors = [];
    },

    async verifyNFeItem() {
      try {
        this.loadingVerify = true;

        let {
          purchase_item: { nfe_code },
          provider_id,
          nfe_change_name_item,
        } = this;

        let params = { code: nfe_code, provider_id };

        const response = await api.get("/rest-home/stock/item/verify", {
          params,
        });

        const { error, errors, exist, stock_item_provider_code } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.exist_nfe_item = exist;
          this.stock_item_provider_code = stock_item_provider_code;
          this.errors = [];

          if (exist) {
            this.purchase_item.stock_item_id =
              stock_item_provider_code.stock_item_id;
            this.stock_item_id = stock_item_provider_code.stock_item_id;
            this.imported_nfe_type = stock_item_provider_code.type;
            this.purchase_item.stock_item_type = stock_item_provider_code.type;
            this.purchase_item.size = stock_item_provider_code.size;
            this.purchase_item.stock_item_unit_of_measurement_id =
              stock_item_provider_code.stock_item_unit_of_measurement_id;
            this.purchase_item.unit_of_measurement_abbreviation =
              stock_item_provider_code.unit_of_measurement_abbreviation;

            if (nfe_change_name_item == 1) {
              this.purchase_item.name = stock_item_provider_code.name;
              this.purchase_item.nfe_name = stock_item_provider_code.name;
              this.purchase_item_nfe_name = stock_item_provider_code.name;
            }

            this.size = stock_item_provider_code.size;
            this.quantity = stock_item_provider_code.size;

            if (this.purchase_item.stock_item_type == "PRODUCT") {
              this.quantity =
                parseFloat(stock_item_provider_code.size) *
                parseFloat(this.amount);
            }
          }
        }

        this.loadingVerify = false;
      } catch (error) {
        this.loadingVerify = false;
        console.log(error);
      }
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          nfe,
          exist_nfe_item,
          link_stock_item, // VINCULAR O PRODUTO/MEDICAMENTO DA NOTA FISCAL EM UM PRODUTO/MEDICAMENTO JÁ CADASTRADO?
          nfe_stock_item_id, // PRODUTO/MEDICAMENTO QUE IRÁ VINCULAR
          imported_nfe,
          imported_nfe_type,
          purchase_item,
          stock_item,
          provider_id,
          stock_item_id,
          lot,
          description,
          due_date,
          amount,
          quantity,
          stock_group_id,
          stock_item_locked,
          value,
          unitary_value,
          size,
          stock_item_unit_of_measurement_id,
          purchase_item_nfe_name,
        } = this;

        let name = purchase_item.name;
        let nfe_name = purchase_item.name;

        if (imported_nfe) {
          if (!exist_nfe_item) {
            if (link_stock_item == "SIM") {
              if (!nfe_stock_item_id) {
                this.errors = [
                  "INFORME O PRODUTO/MEDICAMENTO QUE IRÁ VINCULAR ",
                ];
                return;
              }
            } else {
              if (!["PRODUCT", "MEDICINE"].includes(imported_nfe_type)) {
                this.errors = ["INFORME O TIPO, SE É PRODUTO OU MEDICAMENTO"];
                return;
              }
            }
          }
        }

        if (imported_nfe) {
          if (imported_nfe_type == "MEDICINE") {
            if (!due_date) {
              this.errors = ["INFORME A DATA DE VALIDADE"];
              return;
            }
          }
        } else {
          if (stock_item.stock_item_type == "MEDICINE") {
            if (!due_date) {
              this.errors = ["INFORME A DATA DE VALIDADE"];
              return;
            }
          }
        }

        if (purchase_item.stock_item_id === null) {
          let type;
          if (imported_nfe) {
            type = imported_nfe_type.toLowerCase();
          } else {
            type = stock_item.stock_item_type.toLowerCase();
          }

          let findNfeItem = nfe.nfeProc.NFe.infNFe.det.find(
            (det) => det.prod.cProd._text == purchase_item.nfe_code
          );

          let nfeItem;
          if (findNfeItem) {
            findNfeItem.prod.xProd._text = purchase_item_nfe_name;
            name = purchase_item_nfe_name;
            nfe_name = purchase_item_nfe_name;
            nfeItem = {
              ...findNfeItem.prod,
              stock_item_unit_of_measurement_id,
              size,
              type: imported_nfe_type,
              link_stock_item,
              nfe_stock_item_id,
              exist_nfe_item,
            };
          }

          const data = {
            imported_nfe,
            stock_item_id,
            provider_id,
            code: purchase_item.nfe_code,
            type,
            nfeItem,
          };

          const response = await api.post(
            "/rest-home/stock/stock-item-provider-code",
            data
          );

          const { error, errors } = response.data;

          if (error) {
            this.errors = errors;
            return;
          } else {
            this.errors = [];
          }
        }

        this.$emit("updated", {
          name,
          nfe_name,
          quantity,
          size,
          index: purchase_item.index,
          lot,
          description,
          due_date,
          amount,
          stock_group_id,
          value: stock_item_locked ? purchase_item.value : value,
          unitary_value,
          imported_nfe,
          imported_nfe_type,
          stock_item_type: imported_nfe_type,
          unit_of_measurement_abbreviation:
            purchase_item.unit_of_measurement_abbreviation,
        });

        this.$bvModal.hide("edit_item");
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnShow() {
      let {
        purchase_item: {
          stock_item_id,
          lot,
          description,
          due_date,
          amount,
          stock_group_id,
          value,
        },
      } = this;

      this.stock_item_id = stock_item_id;
      this.lot = lot;
      this.description = description;
      this.due_date = due_date;
      this.amount = amount;
      this.stock_group_id = stock_group_id;
      this.value = value;
    },

    async evOnShown() {},
  },
};
</script>

<style>
</style>